export type SimilarityChipType = 'best' | 'okay' | 'weak';

export const getSimilarityChipType = (score: number): SimilarityChipType => {
  if (score > 80) return 'best';
  if (score >= 50) return 'okay';
  return 'weak';
};
